module.exports = __webpack_public_path__ + "assets/img/34cb-eg.svg";